const DEFAULTS = {
  gutterDefault: 'var(--grid-gutter-default)',
  negativeGutterDefault: 'var(--grid-negative-gutter-default)'
}

export default DEFAULTS
